import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import SignIn from "../views/SignIn.vue";
// Projects
import Project from "@/views/Projects/Project/ProjectPage.vue";
import Projects from "@/views/Projects/ProjectsPage.vue";
import ProjectDetails from "@/views/Projects/Project/ProjectDetails.vue";
import ProjectObslog from "@/views/Projects/Project/ProjectObslog.vue";
import ProjectInsights from "@/views/Projects/Project/ProjectInsights.vue";
import ProjectSummary from "@/views/Projects/Project/ProjectSummary.vue";
import ProjectChat from "@/views/Projects/Project/ProjectChat.vue";
import ProjectSaved from "@/views/Projects/Project/ProjectSaved.vue";
import ProjectFiles from "@/views/Projects/Project/ProjectFiles.vue";
import ProjectRecordings from "@/views/Projects/Project/ProjectRecordings.vue";
import ProjectEarlierResearch from "@/views/Projects/Project/ProjectEarlierResearch.vue";
import { auth } from "@/firebase.js";
import store from "@/store/index.js";
import { guestRedirect } from "./guestFence";

// HR
import PeopleView from "@/views/HR/PeopleView.vue";

// PROFILE
import ProfilePage from "@/views/ProfilePage.vue";

// ADMIN
import AdminPage from "@/views/Admin/AdminPage.vue";
import AdminAI from "@/views/Admin/AdminAI.vue";
import AdminAnalytics from "@/views/Admin/AdminAnalytics.vue";
import AdminRulebooks from "@/views/Admin/AdminRulebooks.vue";
import AdminClients from "@/views/Admin/AdminClients.vue";
import AdminConversationStarters from "@/views/Admin/AdminConversationStarters.vue";
import AdminKennisbank from "@/views/Admin/AdminKennisbank.vue";

// SALES
import SalesPage from "@/views/Sales/SalesPage.vue";
import SalesWerving from "@/views/Sales/SalesWerving.vue";
import SalesBenchmark from "@/views/Sales/SalesBenchmark.vue";
import InboundBenchmark from "@/views/Inbound/InboundBenchmark.vue";

// TOOLS
import ColorPallette from "@/views/Tools/ColorPallette.vue";

// SKILLS
import SkillsPage from "@/views/Skills/SkillsPage.vue";
import SkillLibraryPage from "@/views/Skills/SkillLibraryPage.vue";

// DESIGN PREVIEWS
import PreviewsPage from "@/views/Previews/PreviewsPage.vue";

// CHANGELOG + FEATURE REQUESTS
import ChangelogPage from "@/views/Changelog/ChangelogPage.vue";
import RequestsPage from "@/views/Requests/RequestsPage.vue";

// GUIDE: ALICE IN CLAUDE & CHATGPT (the MCP connector)
import McpGuidePage from "@/views/Mcp/McpGuidePage.vue";

// GUESTS
import GuestSignIn from "@/views/Guest/GuestSignIn.vue";
import AdminGuests from "@/views/Admin/AdminGuests.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    redirect: "/projects",
    meta: {
      nav: true,
    },
  },
  {
    path: "/hr/people",
    name: "People",
    meta: {
      nav: true,
    },
    component: PeopleView,
  },
  {
    path: "/tools/color-pallette",
    name: "Color Palette",
    meta: {
      nav: true,
    },
    component: ColorPallette,
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      nav: false,
    },
    component: ProfilePage,
  },
  {
    path: "/signin",
    name: "Sign In",
    meta: {
      nav: false,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: SignIn,
  },
  {
    path: "/guest",
    name: "Guest Sign In",
    meta: {
      nav: false,
      // Open: the magic-link request and completion both happen while the
      // visitor is not (yet) signed in.
      open: true,
    },
    component: GuestSignIn,
  },
  {
    path: "/projects",
    name: "Projects",
    meta: {
      // The Alice redesign owns its own TopBar + Sidebar, so suppress the
      // global Vuetify v-app-bar / v-navigation-drawer in App.vue.
      nav: false,
    },
    component: Projects,
  },
  {
    path: "/sales",
    name: "Sales",
    meta: {
      nav: true,
    },
    redirect: "/sales/werving",
    component: SalesPage,
    children: [
      {
        path: "/sales/werving",
        name: "Werving",
        meta: {
          nav: true,
        },
        component: SalesWerving,
      },
      {
        path: "/sales/benchmark",
        name: "Sales Benchmark",
        meta: {
          nav: true,
        },
        component: SalesBenchmark,
      },
    ],
  },
  {
    path: "/benchmark/:id",
    name: "Benchmark",
    meta: {
      nav: false,
      open: true,
    },
    component: InboundBenchmark,
  },
  {
    path: "/project/:id",
    name: "Project",
    meta: {
      // The Alice shell inside ProjectPage owns the viewport; suppress the
      // global Vuetify v-app-bar / v-navigation-drawer in App.vue.
      nav: false,
    },
    component: Project,
    children: [
      {
        path: "/project/:id/details",
        name: "Project Details",
        meta: { nav: false },
        component: ProjectDetails,
      },
      {
        path: "/project/:id/earlier-research",
        name: "Project Earlier Research",
        meta: { nav: false },
        component: ProjectEarlierResearch,
      },
      {
        path: "/project/:id/obslog",
        name: "Project Obslog",
        meta: { nav: false },
        component: ProjectObslog,
      },
      {
        path: "/project/:id/insights",
        name: "Project Insights",
        meta: { nav: false },
        component: ProjectInsights,
      },
      {
        path: "/project/:id/summary",
        name: "Project Summary",
        meta: { nav: false },
        component: ProjectSummary,
      },
      {
        path: "/project/:id/chat",
        name: "Project Chat",
        meta: { nav: false },
        component: ProjectChat,
      },
      {
        path: "/project/:id/saved",
        name: "Project Saved",
        meta: { nav: false },
        component: ProjectSaved,
      },
      {
        path: "/project/:id/files",
        name: "Project Files",
        meta: { nav: false },
        component: ProjectFiles,
      },
      {
        path: "/project/:id/recordings",
        name: "Project Recordings",
        meta: { nav: false },
        component: ProjectRecordings,
      },
    ],
  },
  {
    path: "/changelog",
    name: "Changelog",
    meta: {
      // Self-shelled page (own TopBar + Sidebar), same as Projects/Skills.
      nav: false,
    },
    component: ChangelogPage,
  },
  {
    path: "/requests",
    name: "Feature Requests",
    meta: {
      nav: false,
    },
    component: RequestsPage,
  },
  {
    path: "/mcp",
    name: "MCP Guide",
    meta: {
      // Self-shelled page (own TopBar + Sidebar), same as Changelog.
      nav: false,
      // Team only: the guard sends guests to /projects (./guestFence.js).
      teamOnly: true,
    },
    component: McpGuidePage,
  },
  {
    path: "/skills",
    name: "Skills",
    meta: {
      // The Skills shell owns its own TopBar + Sidebar, so suppress the global
      // Vuetify chrome in App.vue (same as Projects/Admin).
      nav: false,
    },
    component: SkillLibraryPage,
  },
  {
    // One skill: an existing id, or "new" for an unsaved draft.
    path: "/skills/:id",
    name: "Skill",
    meta: {
      nav: false,
    },
    component: SkillsPage,
  },
  {
    path: "/previews",
    name: "Previews",
    meta: {
      // Self-shelled page (own TopBar + Sidebar), same as Skills/Changelog.
      nav: false,
    },
    component: PreviewsPage,
  },
  {
    path: "/admin",
    name: "Admin",
    meta: {
      // Admin owns its own alice-shell (TopBar + Sidebar + AdminSubSidebar),
      // so suppress the global Vuetify chrome in App.vue.
      nav: false,
    },
    redirect: "/admin/ai",
    component: AdminPage,
    children: [
      {
        path: "/admin/ai",
        name: "Admin AI",
        meta: {
          nav: false,
        },
        component: AdminAI,
      },
      {
        path: "/admin/analytics",
        name: "Admin Analytics",
        meta: {
          nav: false,
        },
        component: AdminAnalytics,
      },
      {
        path: "/admin/rulebooks",
        name: "Admin Rulebooks",
        meta: {
          nav: false,
        },
        component: AdminRulebooks,
      },
      {
        path: "/admin/clients",
        name: "Admin Clients",
        meta: {
          nav: false,
        },
        component: AdminClients,
      },
      {
        path: "/admin/starters",
        name: "Admin Conversation Starters",
        meta: {
          nav: false,
        },
        component: AdminConversationStarters,
      },
      {
        path: "/admin/guests",
        name: "Admin Guests",
        meta: {
          nav: false,
        },
        component: AdminGuests,
      },
      {
        path: "/admin/kennisbank",
        name: "Admin Kennisbank",
        meta: {
          nav: false,
        },
        component: AdminKennisbank,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  let allowed = auth.currentUser != null;
  // Allow access if route has meta.open === true, or if user is logged in, or if it's the Sign In page
  if (!allowed && to.name !== "Sign In" && !(to.meta && to.meta.open)) {
    next({ name: "Sign In" });
    return;
  }

  // Guests are fenced to the projects list, their granted projects (minus the
  // Details tab), their profile, and the guest sign-in page; team-only pages
  // are never theirs (see ./guestFence.js). Rules and callables enforce the
  // real boundary server-side — this only keeps the UI coherent. Claims come
  // from the cached ID token (no network round-trip).
  if (allowed) {
    const { claims } = await auth.currentUser.getIdTokenResult();
    if (claims.guest) {
      const redirect = guestRedirect(to, store.getters.guestProjectIds || []);
      if (redirect) {
        next(redirect);
        return;
      }
    }
  }

  // The #skills Slack posts link to /skills?skill=<id> (functions/modules/
  // skills/announce.js); those now open the skill's own page. Here rather than
  // in a beforeEnter, which skips a query change on the library itself.
  if (to.name === "Skills" && to.query.skill) {
    next({
      path: `/skills/${encodeURIComponent(to.query.skill)}`,
      replace: true,
    });
    return;
  }

  next();
});

export default router;
